import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { InvoiceAmountCalc } from '@app/core/models/invoices/invoice-amount-calc.model';
import { InvoiceDetailModel } from '@app/core/models/invoices/invoice-detail.model';
import { NumberCommaToDotFormatPipe } from '@app/shared/pipes/number-comma-to-dot-format.pipe';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class AmendmentLibraryService {
  constructor(
    private numberFormatPipe: NumberCommaToDotFormatPipe,
    private decimalPipe: DecimalPipe
  ) {}

  updateExpenseAmountForAllAmendment(
    tvavalue: number,
    invoiceDetailModel: InvoiceDetailModel,
    InvoiceAmendments: UntypedFormArray
  ) {
    for (let i = 0; i < InvoiceAmendments.controls.length; i++) {
      const element = InvoiceAmendments.controls[i] as UntypedFormGroup;
      this.updateExpenseAmountForAmendment(
        invoiceDetailModel,
        InvoiceAmendments,
        i,
        element.controls.CreatedAt.value,
        tvavalue
      );
    }
  }

  updateExpenseAmountForAmendment(
    invoiceDetailModel: InvoiceDetailModel,
    InvoiceAmendments: UntypedFormArray,
    index: number,
    createdAt: number,
    tvavalue: number
  ) {
    var element = invoiceDetailModel.Amendments.find(
      (c) => c.CreatedAt == createdAt
    );

    if (!_.isNil(tvavalue)) {
      const amountTaxExcluded: number = this.numberFormatPipe.transform(
        element.AmountTaxExcluded
      );

      element.AmountTaxExcluded = amountTaxExcluded;
      element.AmountVat = _.toNumber(
        ((amountTaxExcluded * tvavalue) / 100).toFixed(2)
      );
      element.AmountTaxIncluded = _.toNumber(
        (amountTaxExcluded + element.AmountVat).toFixed(2)
      );
    } else {
      element.AmountVat = 0;
      element.AmountTaxIncluded = 0;
    }

    var item = InvoiceAmendments.at(index) as UntypedFormGroup;
    item.controls.AmendmentAmountTaxExcluded.patchValue(
      this.decimalPipe.transform(element.AmountTaxExcluded, '1.2-2')
    );
    item.controls.AmendmentAmountVat.patchValue(
      this.decimalPipe.transform(element.AmountVat, '1.2-2')
    );
    item.controls.AmendmentAmountTaxIncluded.patchValue(
      this.decimalPipe.transform(element.AmountTaxIncluded, '1.2-2')
    );
  }

  setSumAmendments(
    invoiceDetailModel: InvoiceDetailModel,
    invoiceDetailAmountCalc: InvoiceAmountCalc
  ) {
    let amendmentsSumTaxExcluded = 0;
    let amendmentsSumVAT = 0;
    let amendmentsSumTaxIncluded = 0;
    let invoiceSumMarketWithAmendment = 0;

    if (
      invoiceDetailModel.Amendments != null &&
      invoiceDetailModel.Amendments.length > 0
    ) {
      amendmentsSumTaxExcluded = invoiceDetailModel.Amendments.reduce<number>(
        (accumulator, obj) => {
          return (
            accumulator +
            (!_.isNil(obj.AmountTaxExcluded) ? obj.AmountTaxExcluded : 0)
          );
        },
        0
      );

      amendmentsSumVAT = invoiceDetailModel.Amendments.reduce<number>(
        (accumulator, obj) => {
          return accumulator + (!_.isNil(obj.AmountVat) ? obj.AmountVat : 0);
        },
        0
      );

      amendmentsSumTaxIncluded = invoiceDetailModel.Amendments.reduce<number>(
        (accumulator, obj) => {
          return (
            accumulator +
            (!_.isNil(obj.AmountTaxIncluded) ? obj.AmountTaxIncluded : 0)
          );
        },
        0
      );
    }

    const amountTaxExcludedWithoutAmendment = _.isNil(
      invoiceDetailModel.AmountTaxExcludedWithoutAmendment
    )
      ? 0
      : this.numberFormatPipe.transformfromString(
          invoiceDetailModel.AmountTaxExcludedWithoutAmendment.toString()
        );
    invoiceSumMarketWithAmendment =
      amendmentsSumTaxExcluded + amountTaxExcludedWithoutAmendment;

    invoiceDetailAmountCalc.amendmentsSumTaxExcluded =
      this.decimalPipe.transform(amendmentsSumTaxExcluded, '1.2-2');
    invoiceDetailAmountCalc.amendmentsSumVAT = this.decimalPipe.transform(
      amendmentsSumVAT,
      '1.2-2'
    );
    invoiceDetailAmountCalc.amendmentsSumTaxIncluded =
      this.decimalPipe.transform(amendmentsSumTaxIncluded, '1.2-2');

    invoiceDetailAmountCalc.invoiceSumMarketWithAmendment =
      this.decimalPipe.transform(invoiceSumMarketWithAmendment, '1.2-2');
  }
}
